export default "__VITE_PUBLIC_ASSET__5d96d5ae__"